import reduce from 'lodash/reduce'
import constants from 'constants'

const { UI_AVATAR_COLOURS } = constants

function getStringCode(str) {
  const code = reduce(str, (sum, char) => (
    sum + char.charCodeAt(0)
  ), 0)
  return Math.abs(code)
}

export function colourFromString(str) {
  const index = getStringCode(str) % UI_AVATAR_COLOURS.length
  return UI_AVATAR_COLOURS[index]
}




// WEBPACK FOOTER //
// ./src/utils/colours.js